import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getRealRegion } from "./getRealRegion";
import { isFipsRegion } from "./isFipsRegion";
export var resolveRegionConfig = function resolveRegionConfig(input) {
  var _region = input.region,
    _useFipsEndpoint = input.useFipsEndpoint;
  if (!_region) {
    throw new Error("Region is missing");
  }
  return _objectSpread(_objectSpread({}, input), {}, {
    region: function () {
      var _region2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var providedRegion;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof _region === "string")) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", getRealRegion(_region));
              case 2:
                _context.next = 4;
                return _region();
              case 4:
                providedRegion = _context.sent;
                return _context.abrupt("return", getRealRegion(providedRegion));
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function region() {
        return _region2.apply(this, arguments);
      }
      return region;
    }(),
    useFipsEndpoint: function () {
      var _useFipsEndpoint2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var providedRegion;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(typeof _region === "string")) {
                  _context2.next = 4;
                  break;
                }
                _context2.t0 = _region;
                _context2.next = 7;
                break;
              case 4:
                _context2.next = 6;
                return _region();
              case 6:
                _context2.t0 = _context2.sent;
              case 7:
                providedRegion = _context2.t0;
                if (!isFipsRegion(providedRegion)) {
                  _context2.next = 10;
                  break;
                }
                return _context2.abrupt("return", true);
              case 10:
                return _context2.abrupt("return", typeof _useFipsEndpoint !== "function" ? Promise.resolve(!!_useFipsEndpoint) : _useFipsEndpoint());
              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      function useFipsEndpoint() {
        return _useFipsEndpoint2.apply(this, arguments);
      }
      return useFipsEndpoint;
    }()
  });
};